import { Routes, Route, Navigate } from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_metronic/layout/core/PageData'
import { ListUser } from '../users/components/ListUser'
import { TenantsList } from './components/TenantsList'
import { TenantForm } from './components/TenantForm'

const breadcrumbs: Array<PageLink> = [
  {
    title: 'Arteco Admin GUI',
    path: '',
    isSeparator: false,
    isActive: false,
    disableLink: true,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const breadcrumbs_with_lista: Array<PageLink> = [
  {
    title: 'Arteco Admin GUI',
    path: '',
    isSeparator: false,
    isActive: false,
    disableLink: true,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Lista Tenant',
    path: '/tenants',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const TenantsRoutes = () => (
  <Routes>
    <Route
      index
      element={
        <>
          <PageTitle breadcrumbs={breadcrumbs}>Lista Tenant</PageTitle>
          <TenantsList />
        </>
      }
    />

     <Route
          path='add'
          element={
            <>
              <PageTitle breadcrumbs={breadcrumbs_with_lista}>Nuovo utente</PageTitle>
              <TenantForm />
            </>
          }
        />
        <Route
          path='edit/:id'
          element={
            <>
              <PageTitle breadcrumbs={breadcrumbs_with_lista}>Modifica utente</PageTitle>
              <TenantForm />
            </>
          }
        />
    <Route path='*' element={<Navigate to='/error/404' />} />
  </Routes>
)

export {TenantsRoutes}